import styled from "styled-components";
import { COLORS } from "../../../assets/utils/enums/colors";
import {
  LabelText,
  LittleHeadline,
  LittleSubHeadline,
  LittleText,
  NotificationText,
} from "../../typography";
import deleteIcon from "../../../assets/images/icons/delete-icon.svg";
import editIcon from '../../../assets/images/icons/edit-icon.svg';
import addCommentIcon from "../../../assets/images/icons/add-chat-icon.svg";
import { getTimeMinHour } from "../../../assets/utils/date-formatter";
import { useEffect, useState } from "react";
import Input, { InputStyle } from "../inputs";
import { Button } from "../button";
import { AnimatePresence, motion } from "framer-motion";
import { CommentType } from "../../../assets/utils/enums/project";

export const CommentsBlock = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  padding-bottom: 16px;
  ${LittleText}, ${LittleHeadline}, ${LittleSubHeadline} {
    color: ${COLORS.secondary1};
  }
  ${NotificationText} {
    color: ${COLORS["bg-text-color"]};
  }
`;

export default function CommentItem({ item, deleteClick, editClick }: { item: CommentType; deleteClick: () => void; editClick: (id: number, commentValue: string) => void }) {
  const [isEdit, setIsEdit] = useState<boolean>(false);
  const [isEditComment, setIsEditComment] = useState<boolean>(false);
  const [commentValue, setCommentValue] = useState<string>(item.content);

  useEffect(() => {
    setIsEditComment(!(commentValue === item.content));
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [commentValue])


  return (
    <CommentItemStyle>
      <span className="d-flex align-items-start gap-2 w-100">
        <img className="comment-icon" src={addCommentIcon} alt="add-icon" />
        <span className="w-100">
          <LittleHeadline>{item.userFullName}</LittleHeadline>
          {isEdit ? <AnimatePresence><motion.div
            initial={{ opacity: 0, y: -5 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -5 }}
            transition={{ duration: 0.2 }}
            className="d-flex w-100 gap-1"
          ><Input
              attribute="text"
              value={commentValue}
              setValue={setCommentValue}
              errorText={""}
              label=""
              placeholder="Введіть новий коментар тут.."
            /><Button
              bgcolor={COLORS["light-green"]}
              txtcolor={COLORS.main1}
              brcolor={isEditComment ? COLORS.main1 : "transparent"}
              width="auto"
              brradius="24px"
              type="small"
              noactive={!isEditComment}
              disabled={!isEditComment}
              onClick={() => { editClick(item.id, commentValue); setIsEdit(false); }}
            >Оновити
            </Button></motion.div></AnimatePresence> : <LittleText>{item.content}</LittleText>}
        </span>{" "}
      </span>{" "}
      <span className="d-flex flex-column justify-content-between align-items-end">
        <span className="d-flex gap-2 align-items-center">{item.updatedAt && <NotificationText>(відредаговано)</NotificationText>}<NotificationText>{getTimeMinHour(item.createdAt)}</NotificationText></span>
        {!isEdit && <AnimatePresence><motion.div
          initial={{ opacity: 0, y: 5 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 5 }}
          transition={{ duration: 0.2 }}
          className="d-flex gap-2 align-items-center"
        > {item.isEdit && <img
          className="delete-icon"
          src={editIcon}
          alt="edit-icon"
          onClick={() => setIsEdit(!isEdit)}
        />}
          {item.isDelete && <img
            className="delete-icon"
            src={deleteIcon}
            alt="delete-icon"
            onClick={deleteClick}
          />}
        </motion.div></AnimatePresence>}
      </span>
    </CommentItemStyle>
  );
}

const CommentItemStyle = styled.div`
  background-color: ${COLORS.gray};
  border-radius: 24px;
  padding: 12px 20px;
  display: flex;
  width: 100%;
  justify-content: space-between;
  gap: 16px;

  .comment-icon {
    background-color: ${COLORS.white};
    border-radius: 8px;
    padding: 8px;
    margin-right: 10px;
  }
  .delete-icon {
    width: 20px;
    height: 20px;
    cursor: pointer;
    transition: transform 0.3s cubic-bezier(0.165, 0.84, 0.44, 1);

    &:active {
      transform: scale(0.9);
    }
  }
  
  ${Button} { 
   ${NotificationText.componentStyle.rules.join("")}
   font-weight: 600;
}

  ${InputStyle} {
    position: relative;
    left: -5px;
    span {
      background-color: ${COLORS.white};
      padding: 6px 12px;
      border: 1px solid ${COLORS["light-bg-color"]};
    input {
      font-size: 14px;
    }
  }
  
  padding: 0;
  padding-top: 6px;
    ${LabelText} {
      display: none;
    }
  }
`;
